import React, { useMemo } from 'react'

import * as authAccess from '@/utils/authAccess'

export interface AuthContextInterface {
	canCreateSystem: () => boolean
	canDeleteSystem: () => boolean
	canForceUnlock: () => boolean
	canManageLOVs: () => boolean
	canManageTemplates: () => boolean
	canManageUsers: () => boolean
	canSeeSettings: () => boolean
	isAdmin: () => boolean
	isPrivilegedUser: () => boolean
	isReader: () => boolean
	isSupport: () => boolean
}

export const AuthContext = React.createContext<AuthContextInterface | null>(
	null,
)

export const AuthContextProvider = ({
	children,
}: {
	children: React.ReactNode
}) => {
	const model = useMemo(
		(): AuthContextInterface => ({
			canManageUsers: authAccess.canManageUsers,
			canManageLOVs: authAccess.canManageLOVs,
			canManageTemplates: authAccess.canManageTemplates,
			canCreateSystem: authAccess.canCreateSystem,
			canDeleteSystem: authAccess.canDeleteSystem,
			canForceUnlock: authAccess.canForceUnlock,
			canSeeSettings: authAccess.canSeeSettings,
			isReader: authAccess.isRealmReader,
			isSupport: authAccess.isSupportUser,
			isPrivilegedUser: authAccess.isPrivilegedUser,
			isAdmin: authAccess.isRealmAdmin,
		}),
		[],
	)

	return <AuthContext.Provider value={model}>{children}</AuthContext.Provider>
}
